import { devtools } from 'zustand/middleware';
import { create } from './advnacedActions';

const initialState = {
  balance: {
    total: 0,
    credit: 0,
    hasPromo: false,
    promoUsage: 0,
    promoExpirationDate: null,
    isLoading: true,
    error: null,
  },
  paymentMethod: {
    card: null,
    isLoading: true,
    error: null,
  },
  transactions: [],
  stats: {},
  usage: {
    chart: [],
    isLoading: true,
    totalUsage: 0,
    error: null,
  },
};

let paymentsStore = (set, get) => ({
  ...initialState,
  setBalance: (balance = initialState.balance) => set({ balance }),
  setPaymentMethod: (paymentMethod = initialState.paymentMethod) => set({ paymentMethod }),
  setTransactions: (transactions) => set({ transactions }),
  setStats: (stats) => set({ stats }),
  setUsage: (usage = initialState.usage) => set({ usage }),
  reset: () => set({ ...initialState }),
});

paymentsStore = devtools(paymentsStore);

const usePaymentsStore = create(paymentsStore);

export default usePaymentsStore;
